export default __webpack_public_path__ + "static/nayounkim-logo-19cbe269ef8d3a557aa7718aaff8c5ca.png";